import {bindable, customElement, autoinject} from "aurelia-framework";
// import flatpickr from 'flatpickr'

@customElement('date-picker')
@autoinject
export class DatePicker
{
  @bindable() cssClass;
  @bindable() placeholder;
  @bindable() dateValue;
    private element: any;
    private pickerOptions: any;
    @bindable() hideHeader: boolean;
  

  constructor(element : Element) {
   this.element = element;
   this.pickerOptions  = {} as any;
  }

  bind(){
    // flatpickr(this.element.firstElementChild, this.pickerOptions);
  }
  attached(){
   
  }
  

}


